import axios from 'axios';
import * as actionTypes from '../actions/types';

const baseUrl = process.env.NODE_ENV === 'development' ? 
    process.env.REACT_APP_DEV_API_BASE_URL : process.env.REACT_APP_PROD_API_BASE_URL;

export const fetchProfiles = id => async dispatch => {
    var res = await axios.get(`${baseUrl}/api/profiles/matches/${id}`);
    dispatch({ type: actionTypes.FETCH_PROFILES, payload: res.data })
}

export const collectProfileData = (profile) => dispatch => {
    dispatch({ type: actionTypes.COLLECT_PROFILE_DATA, payload: profile });
}

export const preferenceFilterUpdate = preferenceFilters => dispatch => {
    localStorage.setItem('preferences', JSON.stringify(preferenceFilters));
    dispatch({ type: actionTypes.PREFERENCE_FILTERS_UPDATE, payload: preferenceFilters });
}

const resetValues = {
    userId: null,
    profileName: '',
    dateOfBirth: '',
    gender: '',
    profilePictures: [],
    universityInfo: {},
    interests: [],
    virtues: { 
        genderPreference: '', 
        ethnicity: '', 
        religion: '', 
        politicalView: '', 
        smoking: '', 
        drinking: '', 
        height: ''
    },
    bio: '',
    isActive: true,
    profilePrompts: []
};

export const resetProfileData = resetValues => {
    return { type: actionTypes.COLLECT_PROFILE_DATA, profile: resetValues };
}

export const createProfile = profile => async dispatch => {
    await axios.post(`${baseUrl}/api/profiles`, profile)
        .then(res => {
            localStorage.setItem('userProfile', JSON.stringify(res.data.userProfile));
            dispatch({ type: actionTypes.CREATE_PROFILE, payload: res.data.userProfile });
            dispatch(resetProfileData(resetValues));
        })
        .catch(() => {
            dispatch({ type: actionTypes.CREATE_PROFILE, payload: null, errors: 'User does not have profile' });
            dispatch(resetProfileData(resetValues));
        })
}

export const updateProfile = profile => async dispatch => {
    await axios.put(`${baseUrl}/api/profiles/${profile.profileId}`, profile)
        .then(res => {
            localStorage.setItem('userProfile', JSON.stringify(res.data.userProfile));
            dispatch({ type: actionTypes.UPDATE_PROFILE, payload: res.data.userProfile });
        })
        .catch(() => {
            dispatch({ type: actionTypes.UPDATE_PROFILE, payload: localStorage.getItem('userProfile'), errors: 'Could not update profile' });
        });
}

export const deleteProfiles = id => async dispatch => {
    await axios.delete(`${baseUrl}/api/profiles/${id}`)
        .then(res => {
            localStorage.removeItem('user');
            localStorage.removeItem('userProfile');
            localStorage.removeItem('expirationDate');
            dispatch({ type: actionTypes.DELETE_PROFILE });
        })
        .catch(() => {
            dispatch({ type: actionTypes.DELETE_PROFILE, payload: null, errors: 'Error Deleting profile' });
            dispatch(resetProfileData(resetValues));
        })
}

export const addProfilePrompts = profilePrompt => async dispatch => {
    await axios.post(`${baseUrl}/api/profileprompts`, profilePrompt)
        .then(res => {
            const userProfileData = JSON.parse(localStorage.getItem('userProfile'));
            localStorage.setItem('userProfile', JSON.stringify({...userProfileData, profilePrompts: res.data}));
            dispatch({ type: actionTypes.ADD_PROFILE_PROMPTS, payload: res.data });
        })
        .catch(() => {
            const userProfileData = JSON.parse(localStorage.getItem('userProfile'));
            dispatch({ type: actionTypes.ADD_PROFILE_PROMPTS, payload: userProfileData.profilePrompts, errors: 'Could not update profile' });
        });
}

export const updateProfilePrompt = profilePrompt => async dispatch => {
    await axios.put(`${baseUrl}/api/profileprompts/${profilePrompt.promptId}`, profilePrompt)
        .then(res => {
            const userProfileData = JSON.parse(localStorage.getItem('userProfile'));
            localStorage.setItem('userProfile', JSON.stringify({...userProfileData, profilePrompts: res.data}));
            dispatch({ type: actionTypes.UPDATE_PROFILE_PROMPT, payload: res.data });
        })
        .catch(() => {
            const userProfileData = JSON.parse(localStorage.getItem('userProfile'));
            dispatch({ type: actionTypes.UPDATE_PROFILE_PROMPT, payload: userProfileData.profilePrompts, errors: 'Could not update profile' });
        });
}

export const addProfileInterests = interest => async dispatch => {
    await axios.post(`${baseUrl}/api/interests`, interest)
        .then(res => {
            localStorage.setItem('userProfile', JSON.stringify(res.data.userProfile));
            dispatch({ type: actionTypes.ADD_PROFILE_INTEREST, payload: res.data.userProfile });
        })
        .catch(() => {
            dispatch({ type: actionTypes.ADD_PROFILE_INTEREST, payload: localStorage.getItem('userProfile'), errors: 'Could not update profile' });
        });
}

export const removeProfileInterests = id => async dispatch => {
    await axios.delete(`${baseUrl}/api/interests/${id}`)
        .then(res => {
            localStorage.setItem('userProfile', JSON.stringify(res.data.userProfile));
            dispatch({ type: actionTypes.REMOVE_PROFILE_INTEREST, payload: res.data.userProfile });
        })
        .catch(() => {
            dispatch({ type: actionTypes.REMOVE_PROFILE_INTEREST, payload: localStorage.getItem('userProfile'), errors: 'Could not update profile' });
        });
}

export const addProfilePhoto = photo => async dispatch => {
    await axios.post(`${baseUrl}/api/profilephotos`, photo)
        .then(res => {
            const userProfileData = JSON.parse(localStorage.getItem('userProfile'));
            localStorage.setItem('userProfile', JSON.stringify({...userProfileData, profilePhotos: res.data}));
            dispatch({ type: actionTypes.ADD_PROFILE_PHOTO, payload: res.data });
        })
        .catch(() => {
            dispatch({ type: actionTypes.ADD_PROFILE_PHOTO, payload: localStorage.getItem('userProfile'), errors: 'Could not update profile' });
        });
}

export const removeProfilePhoto = id => async dispatch => {
    await axios.delete(`${baseUrl}/api/profilephotos/${id}`)
        .then(res => {
            const userProfileData = JSON.parse(localStorage.getItem('userProfile'));
            localStorage.setItem('userProfile', JSON.stringify({...userProfileData, profilePhotos: res.data}));
            dispatch({ type: actionTypes.REMOVE_PROFILE_PHOTO, payload: res.data });
        })
        .catch(() => {
            const userProfileData = JSON.parse(localStorage.getItem('userProfile'));
            dispatch({ type: actionTypes.REMOVE_PROFILE_PHOTO, payload: userProfileData.profilePhotos, errors: 'Could not update profile' });
        });
}

export const resetVirtue = () => dispatch => {
    dispatch({ type: actionTypes.RESET_VIRTUE });
}

export const previousVirtue = () => dispatch => {
    dispatch({ type: actionTypes.PREVIOUS_VIRTUE });
}

export const nextVirtue = () => dispatch => {
    dispatch({ type: actionTypes.NEXT_VIRTUE });
}